<style scoped>
@import url('https://fonts.googleapis.com/css?family=Mr+De+Haviland');

.headline {
  font-size: 5em;
  font-family: 'Mr De Haviland', cursive;
  font-weight: 400;
  color: #3E9DCA;
  padding-top: 30px;
}

.summary .list-group-item .header {
  cursor: pointer;
  font-size: 16px;
  width: 100% !important;
  font-size: 1.2rem;
}

.light-bg * {
  background-color: #f8f9fa !important;
}
</style>

<template>
  <div class="container" v-if="deal">
    <b-row>
      <b-col class="text-center">
        <h1 class="headline">Thank&nbsp;&nbsp;You!</h1>
        <h5>Your deal has been submitted.</h5>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <b-card
          :title="title"
          class="bg-light"
        >
          <b-card-sub-title v-html="subtitle" />
          <b-card-body>
            <b-list-group class="summary light-bg">
              <b-list-group-item
                class="flex-column align-items-start"
                v-b-toggle.property-collapse
              >
                <div class="header">Property</div>
                <b-collapse id="property-collapse" class="mt-2" visible>
                  <b-card>
                    <b-row>
                      <b-col>
                        <b-row>
                          <b-col md="9">
                            <div><strong>Address</strong></div>
                            <div>{{ deal.property.address.address }}</div>
                          </b-col>
                          <b-col md="3">
                            <div><strong>Unit</strong></div>
                            <div>{{ deal.property.address.unit || '-' }}</div>
                          </b-col>
                        </b-row>
                        <b-row class="mt-3">
                          <b-col md="6">
                            <div><strong>City</strong></div>
                            <div>{{ deal.property.address.city }}</div>
                          </b-col>
                          <b-col md="3">
                            <div><strong>State</strong></div>
                            <div>{{ deal.property.address.state }}</div>
                          </b-col>
                          <b-col md="3">
                            <div><strong>Zip Code</strong></div>
                            <div>{{ deal.property.address.zipCode }}</div>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="left-border">
                        <div>
                          <strong>{{ titleMapper.property.items.status }}:</strong>
                          {{ valueMapper.property.status[deal.property.status] }}
                        </div>
                        <div v-if="deal.property.closingStatus">
                          <strong>{{ titleMapper.property.items.closingStatus }}:</strong>
                          {{ valueMapper.property.closingStatus[deal.property.closingStatus] }}
                        </div>
                        <div>
                          <div>
                            <strong>{{ titleMapper.property.items.visit }}:</strong>
                            {{ valueMapper.property.visit.titles[deal.property.visit.type] }}
                          </div>
                          <div class="ml-3">
                            <b-row
                              v-if="deal.property.visit.type !== 'other'"
                              v-html="visitHtml"
                            >
                            </b-row>
                            <b-row>
                              <b-col>
                                <div><strong>Notes:</strong></div>
                                <div>
                                  {{
                                    deal.property.visit[
                                      valueMapper.property.visit.types[deal.property.visit.type]
                                    ].notes
                                  }}
                                </div>
                              </b-col>
                            </b-row>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-collapse>
              </b-list-group-item>


              <b-list-group-item
                class="flex-column align-items-start mt-3"
                v-b-toggle.transaction-data-collapse
              >
                <div class="header">Transaction Data</div>
                <b-collapse id="transaction-data-collapse" class="mt-2">
                  <b-card>
                    <div v-if="helper.isRefinance(deal)">
                      <div>
                        <strong>{{ titleMapper.refinance.items.price }}:</strong>
                        {{ deal.refinance.price | currency }}
                      </div>
                      <div>
                        <div>
                          <strong>{{ titleMapper.refinance.items.debt }}:</strong>
                          {{ deal.refinance.debt | bool }}
                        </div>
                        <div
                          v-if="deal.refinance.debt === true && deal.refinance.liens.length !== 0"
                        >
                          <strong>Liens</strong>
                          <div class="ml-3 mr-3">
                            <div
                              v-for="lien in deal.refinance.liens"
                              v-bind:key="lien.price"
                            >
                              <strong>Price:</strong> $ {{ lien.price | currency }}
                              <span v-if="lien.payoff">
                                - Should payoff with new loan from Anchor
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <strong>{{ titleMapper.refinance.items.closingDate }}:</strong>
                        {{ deal.refinance.closingDate }}
                      </div>
                    </div>
                    <div v-else>
                      <div>
                        <strong>{{ titleMapper.purchase.items.price }}:</strong>
                        {{ deal.purchase.price | currency }}
                      </div>
                      <div>
                        <strong>{{ titleMapper.purchase.items.type }}:</strong>
                        {{ valueMapper.purchase.type[deal.purchase.type] }}
                      </div>
                      <div v-if="helper.isShortSale(deal.purchase)">
                        <div>
                          <strong>{{ titleMapper.purchase.items.shortSaleApproval }}:</strong>
                          {{ deal.purchase.shortSaleApproval | bool }}
                        </div>
                        <div>
                          <strong>{{ titleMapper.purchase.items.hasSecondLien }}:</strong>
                          {{ deal.purchase.hasSecondLien | bool }}
                        </div>
                        <div v-if="helper.hasSecondLien(deal.purchase)">
                          <div>
                            <strong>{{ titleMapper.purchase.items.hasSecondLienApproval }}:</strong>
                            {{ deal.purchase.hasSecondLienApproval | bool }}
                          </div>
                        </div>
                      </div>
                      <div>
                        <strong>{{ titleMapper.purchase.items.contractExists }}:</strong>
                        {{ deal.purchase.contractExists | bool }}
                      </div>
                      <div>
                        <strong>{{ titleMapper.purchase.items.closingDate }}:</strong>
                        {{ deal.purchase.closingDate }}
                      </div>
                    </div>
                  </b-card>
                </b-collapse>
              </b-list-group-item>

              <b-list-group-item
                class="flex-column align-items-start mt-3"
                v-b-toggle.property-repairs-collapse
                v-if="helper.displayRepairs(deal)"
              >
                <div class="header">Repairs</div>
                <b-collapse id="property-repairs-collapse" class="mt-2">
                  <b-card>
                    <b-row>
                      <b-col>
                        <div v-if="deal.propertyRepair.afterRepairEstimate">
                          <strong>
                            {{ titleMapper.propertyRepair.items.afterRepairEstimate }}:
                          </strong>
                          {{ deal.propertyRepair.afterRepairEstimate | currency }}
                        </div>
                        <div v-if="deal.propertyRepair.totalCost">
                          <strong>{{ titleMapper.propertyRepair.items.totalCost }}:</strong>
                          {{ deal.propertyRepair.totalCost | currency }}
                        </div>
                        <div v-if="typeof(deal.propertyRepair.holdback) === 'boolean'">
                          <strong>{{ titleMapper.propertyRepair.items.holdback }}:</strong>
                          {{ deal.propertyRepair.holdback | bool }}
                        </div>
                        <div v-if="helper.isRefinance(deal)">
                          <div>
                            <strong>
                              {{ titleMapper.propertyRepair.items.totalAmountCompleted }}:
                            </strong>
                            {{
                              deal.propertyRepair.totalAmountCompleted ?
                                `$ ${toCurrency(deal.propertyRepair.totalAmountCompleted)}` :
                                '-'
                            }}
                          </div>
                          <div>
                            <strong>
                              {{ titleMapper.propertyRepair.items.totalAmountRemaining }}:
                            </strong>
                            {{
                              deal.propertyRepair.totalAmountRemaining ?
                                `$ ${toCurrency(deal.propertyRepair.totalAmountRemaining)}` :
                                '-'
                            }}
                          </div>
                        </div>
                      </b-col>
                      <b-col
                        class="left-border"
                        v-if="helper.rehabOrOther(deal)||helper.shouldDisplayAdditionalField(deal)"
                      >
                        <div v-if="helper.rehabOrOther(deal)">
                          <strong>
                            {{ titleMapper.propertyRepair.items.hasAdditionalSqFt }}:
                          </strong>
                          {{ deal.propertyRepair.hasAdditionalSqFt | bool }}
                        </div>
                        <div v-if="helper.shouldDisplayAdditionalField(deal)">
                          <div>
                            <strong>
                              {{ titleMapper.propertyRepair.items.additionalRooms }}:
                            </strong>
                            {{ deal.propertyRepair.additionalRooms }}
                          </div>
                          <div>
                            <strong>
                              {{ titleMapper.propertyRepair.items.additionalBathrooms }}:
                            </strong>
                            {{ deal.propertyRepair.additionalBathrooms }}
                          </div>
                          <div>
                            <strong>
                              {{ titleMapper.propertyRepair.items.additionalSqFt }}:
                            </strong>
                            {{ deal.propertyRepair.additionalSqFt }}
                          </div>
                          <div>
                            <strong>
                              {{ titleMapper.propertyRepair.items.totalSqFtAfterRepairs }}:
                            </strong>
                            {{ deal.propertyRepair.totalSqFtAfterRepairs }}
                          </div>
                          <div>
                            <strong>
                              {{ titleMapper.propertyRepair.items.permits }}:
                            </strong>
                            {{ deal.propertyRepair.permits.exists | bool }}
                          </div>
                          <div v-if="!deal.propertyRepair.permits.exists" class="ml-3">
                            <strong>
                              Explanation:
                            </strong>
                            {{ deal.propertyRepair.permits.explanation }}
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-collapse>
              </b-list-group-item>

              <b-list-group-item
                class="flex-column align-items-start mt-3"
                v-b-toggle.crosses-collapse
                v-if="Array.isArray(deal.property.crosses) && deal.property.crosses.length > 0"
              >
                <div class="header">Crosses</div>
                <b-collapse id="crosses-collapse" class="mt-2">
                  <b-card>
                    <div
                      class="pb-3 pt-3"
                      v-for="cross in deal.property.crosses"
                      v-bind:key="cross.id"
                    >
                      <b-row>
                        <b-col md="10" offset-md="1">
                          <cross-display :cross="cross"/>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card>
                </b-collapse>
              </b-list-group-item>

            </b-list-group>
          </b-card-body>

          <div slot="footer" class="text-center">
            <router-link
              :to="{ name: 'MyDeals'}"
              class="btn btn-anchor"
            >
                Deals in Progress
            </router-link>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CrossDisplay from '@/components/utils/properties/CrossDisplay';

import jshelper from '@/libs/helper';
import dealHelper from '@/components/new_deal/libs/helper';
import gTitleMapper from '@/components/new_deal/resources/titleMapper.json';
import generalMapper from '@/components/new_deal/resources/generalMapper.json';

export default {
  components: {
    CrossDisplay,
  },
  props: {
    deal: Object,
  },
  data() {
    return {
      user: this.$store.getters.user,
      titleMapper: gTitleMapper,
      valueMapper: generalMapper,
      helper: dealHelper,
    };
  },
  computed: {
    title() {
      if (!this.deal.transactionType.name) { return ''; }

      return generalMapper.transactionType[this.deal.transactionType.name];
    },
    subtitle() {
      const dealType = this.deal.dealType;
      const propertyType = this.deal.propertyType;
      if (!(dealType && propertyType)) { return ''; }

      let type = generalMapper.dealType[dealType.name];
      if (dealType.description) {
        type += ` - ${jshelper.decodeHtml(dealType.description)}`;
      }

      return `
        <div><strong>Entity:</strong> ${jshelper.decodeHtml(this.deal.entity.entity.name)}</div>
        <div><strong>Deal Type:</strong> ${jshelper.decodeHtml(type)}</div>
        <div><strong>Property Type:</strong> ${jshelper.decodeHtml(generalMapper.propertyType[propertyType.name])}</div>
      `;
    },
    visitHtml() {
      const visit = this.deal.property.visit;
      if (!visit) { return 12; }

      const type = visit[this.valueMapper.property.visit.types[visit.type]];
      const cols = type.code || type.name ? 6 : 12;
      const mapper = this.valueMapper.property.visit.values[visit.type];

      let html = '';
      Object.keys(mapper).forEach((key) => {
        if (key !== 'notes') {
          html += `<div class="col-md-${cols}">
            <div><strong>${mapper[key]}:</strong></div>
            <div>${jshelper.decodeHtml(type[key])}</div>
          </div>`;
        }
      });

      return html;
    },
  },
  methods: {
    toCurrency: jshelper.currency,
  },
  created() {
    if (!this.deal) {
      this.$router.push({ name: 'Dashboard' });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/new_deal/components/DealConfirmation.vue